import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PageBanner from '../components/PageBanner';
import { CruiseCard } from '../components/Cards';
import { publicApi } from '../api/client';
import { Loader2, Filter } from 'lucide-react';
import { Button } from '../components/ui/button';

const CATEGORIES = ['All', 'Luxury Nile', 'Deluxe Nile River', 'Standard Nile River', 'Dahabiya Nile'];

const CruisesList = () => {
  const [params, setParams] = useSearchParams();
  const activeCategory = params.get('category') || 'All';
  const [cruises, setCruises] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const p = activeCategory === 'All' ? {} : { category: activeCategory };
    publicApi.getCruises(p).then((d) => { setCruises(d); setLoading(false); }).catch(() => setLoading(false));
  }, [activeCategory]);

  const setCat = (c) => {
    const p = new URLSearchParams(params);
    if (c === 'All') p.delete('category'); else p.set('category', c);
    setParams(p);
  };

  return (
    <>
      <PageBanner
        title="Nile Cruises in Egypt"
        subtitle="Egypt's complete collection of Nile river cruises — hand-picked ships between Luxor and Aswan for every style and budget."
        image="https://images.unsplash.com/photo-1575501376367-6711b9b5756b?crop=entropy&cs=srgb&fm=jpg&q=85"
        crumbs={[{ label: 'Nile Cruises' }]}
      />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between flex-wrap gap-4 mb-10">
            <div className="flex items-center gap-2 text-slate-600"><Filter size={16} /> <span className="text-sm">Filter by category:</span></div>
            <div className="flex flex-wrap gap-2">
              {CATEGORIES.map((c) => (
                <Button key={c} variant={activeCategory === c ? 'default' : 'outline'} size="sm" onClick={() => setCat(c)} className={`rounded-full ${activeCategory === c ? 'bg-[#304b71] hover:bg-[#6a8aa4] text-white' : 'border-slate-200 text-slate-700 hover:border-[#304b71] hover:text-[#304b71]'}`}>{c}</Button>
              ))}
            </div>
          </div>

          {loading ? (
            <div className="py-24 text-center text-slate-400"><Loader2 className="animate-spin inline" /></div>
          ) : cruises.length === 0 ? (
            <div className="py-24 text-center text-slate-500">No cruises found in this category.</div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {cruises.map((c) => <CruiseCard key={c.id} cruise={c} />)}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default CruisesList;
